import React from "react";
import { Checkbox, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";

function fileLabel(file, t) {
  if (file?.section === "internal") {
    return `${t("Internal Files")} — ${file.name}`;
  }
  if (file?.section === "consultant") {
    return `${t("Consultant Files")} — ${file.name}`;
  }
  return file?.name || "";
}

export default function EntityEmailStoredFiles({
  files,
  selectedIds,
  onChange,
  disabled,
}) {
  const { t } = useTranslation();
  const list = Array.isArray(files) ? files : [];
  const selected = Array.isArray(selectedIds) ? selectedIds : [];

  const toggle = (id, checked) => {
    if (checked) {
      onChange(selected.includes(id) ? selected : [...selected, id]);
      return;
    }
    onChange(selected.filter((item) => item !== id));
  };

  return (
    <Stack spacing={6}>
      <Text size="sm" weight={600}>
        {t("Files on this record")}
      </Text>
      {list.length ? (
        list.map((file) => (
          <Checkbox
            key={file.id}
            label={fileLabel(file, t)}
            checked={selected.includes(file.id)}
            disabled={disabled}
            onChange={(event) => toggle(file.id, event.currentTarget.checked)}
          />
        ))
      ) : (
        <Text size="xs" color="dimmed">
          {t("No files on this record")}
        </Text>
      )}
    </Stack>
  );
}
